export const redirect = (to) => {
    window.location.href = to;
}
